import {
  AGENT_STATUS,
  Button,
  FlyoutPanel,
  Modal,
  Popover,
  PROFILE_FLYOUT,
  SvgBreakStatus,
  SvgBurger,
  SvgCallIconWorkflow,
  SvgDropdownArrowGrey,
  SvgLunchStatus,
  SvgOfflineStatus,
  SvgOutboundStatus,
  SvgReportsStatus,
} from '@ui-kit'
import { SvgLogo } from '../../assets'
import { RootState, useAppDispatch, useAppSelector } from '../utils/agent.store'
import BreadCrumb from './BreadCrumb'
import { useContext, useEffect, useRef, useState } from 'react'
import { WebSocketContext } from '../context/WebSocketContext'
import {
  addToaster,
  AuthUser,
  setAgentSubscribeTime,
  setClientDropdown,
  setDialPad,
  toggleCCP,
  setProgramDropdown,
} from '@app-store'
import { v4 as uuid } from 'uuid'
import { NAMESPACES } from '../utils/constants'
import { environment } from '../utils/environment'
import {
  formatSessionLoginAt,
  formatSessionTimeRemaining,
  mandatorySessionExtensionSlotMs,
  useMandatoryReloginRemainingMs,
  useSessionIdleCountdown,
} from '@ecrm-session'
import { ConnectedUser } from '../types/types'
import { AWS_STRINGS, STRINGS } from '../utils/strings'
import ClientDropdown from '../common/ClientDropdown'
import { useLocation } from 'react-router-dom'
import ClientProgramDropdown from '../common/ClientProgramDropdown'
import MyProfile from '../pages/MyProfile.page'

interface TopBarPropsType {
  logOutClick: () => void
  toggleSideNav: () => void
  sideNavOpen: boolean
}

const TopBar = ({
  logOutClick,
  toggleSideNav,
  sideNavOpen,
}: TopBarPropsType) => {
  const user = useAppSelector((state) => state?.authUser?.user)
  const [openProfilePanel, setOpenProfilePanel] = useState<boolean>(false)
  const showCCP = useAppSelector((state) => state?.tabUI?.showCCP ?? true)
  const isLeader = useAppSelector((state) => state?.tabUI?.isLeader ?? false)
  const agentStatus = useAppSelector((state) => state?.awsCall?.agentStatus)
  const userAuth = useAppSelector((state) => state?.authUser)
  const [isActive, setIsActive] = useState<boolean>(false)
  const selectedId = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant?.id
  )
  const isAwsPermission = useAppSelector(
    (state) => state?.awsCall?.awsPermission?.value
  )
  const dispatch = useAppDispatch()
  const loginTime = useAppSelector(
    (state: RootState) => state.authUser?.agentSubscribeTime?.subscribeTime
  )
  const clientDropdownData = useAppSelector(
    (state: RootState) => state.clientDropdownState.clientDropdown
  )
  const programDropdownData = useAppSelector(
    (state: RootState) => state.clientDropdownState.programDropdown
  )
  const location = useLocation()
  const { wsHelper, sendMessage, connectionId, uid, messages } =
    useContext(WebSocketContext)
  const { remainingMs } = useSessionIdleCountdown()
  const sessionLoginAtMs = useAppSelector(
    (state: RootState) => state.session.sessionLoginAtMs ?? 0
  )
  const maxSessionExtensionCount = useAppSelector(
    (state: RootState) => state.session.maxSessionExtensionCount ?? 0
  )
  const mandatoryReloginRemainingMs = useMandatoryReloginRemainingMs(
    environment.mandatoryReloginAfterMinutes,
    sessionLoginAtMs,
    maxSessionExtensionCount,
    mandatorySessionExtensionSlotMs(
      environment.mandatorySessionExtensionSlotMinutes
    )
  )

  const getInitials = (fullName: string) => {
    fullName = fullName.trim()
    const nameParts = fullName.split(' ')
    if (nameParts.length < 2) {
      throw new Error(NAMESPACES.FULLNAME_ERROR_MSG)
    }
    const firstNameInitial = nameParts[0].charAt(0).toUpperCase()
    const lastNameInitial = nameParts[nameParts.length - 1]
      .charAt(0)
      .toUpperCase()
    return `${firstNameInitial}${lastNameInitial}`
  }
  const buttonRef = useRef<HTMLButtonElement>(null)
  const [openFlyoutPanel, setOpenFlyoutPanel] = useState<boolean>(false)
  const [display, setDisplay] = useState<string | undefined>(
    localStorage.getItem('display-setting')
      ? JSON.parse(localStorage.getItem('display-setting') ?? '')
      : PROFILE_FLYOUT.COMFY
  )
  const handleThemeChange = (displayValue?: string) => {
    if (displayValue === PROFILE_FLYOUT.COMPACT) {
      document?.body?.classList?.remove('comfy')
      document?.body?.classList?.add('compact')
    } else {
      document?.body?.classList?.remove('compact')
      document?.body?.classList?.add('comfy')
    }
  }
  const handleRadioChange = (
    e: React.ChangeEvent<HTMLInputElement> | undefined
  ) => {
    const displayValue = e?.target?.value
    e?.stopPropagation()
    setDisplay(displayValue)
  }
  // const handleToggle = () => {
  //   const route_key = isActive
  //     ? NAMESPACES.AGENT_OFFLINE
  //     : NAMESPACES.AGENT_ONLINE

  //   if (wsHelper && sendMessage) {
  //     sendMessage(
  //       JSON.stringify({
  //         requestContext: {
  //           routeKey: route_key,
  //           userId: `${user?.user_id}`,
  //           'x-tenantId': selectedId?.toString(),
  //           entity: NAMESPACES.AGENT_AVAILABILITY,
  //           connectionId,
  //           uid,
  //         },
  //       })
  //     )
  //   }

  //   const newActiveState = !isActive
  //   setIsActive(newActiveState)
  //   localStorage.setItem(STRINGS.ISACTIVE, newActiveState.toString())
  // }
  const hanldeSendMessage = (
    wsHelper: WebSocket | null,
    sendMessage: ((message: string) => void) | undefined,
    connectionId: string | undefined,
    user: AuthUser | null,
    uid: string | undefined,
    selectedId: number | undefined
  ) => {
    if (localStorage.getItem(STRINGS.ISACTIVE) === 'true') {
      setIsActive(true)
      if (wsHelper && sendMessage && connectionId) {
        sendMessage(
          JSON.stringify({
            requestContext: {
              routeKey: NAMESPACES.AGENT_ONLINE,
              userId: `${user?.user_id}`,
              'x-tenantId': selectedId?.toString(),
              entity: NAMESPACES.AGENT_AVAILABILITY,
              connectionId,
              uid,
            },
          })
        )
      }
    }
  }
  const sendMessageWbs = (connectedUser: ConnectedUser | undefined) => {
    if (wsHelper && sendMessage && connectionId) {
      sendMessage(
        JSON.stringify({
          requestContext: {
            routeKey:
              connectedUser?.action === STRINGS.ONLINE
                ? NAMESPACES.AGENT_ONLINE
                : NAMESPACES.AGENT_OFFLINE,
            userId: `${user?.user_id}`,
            'x-tenantId': selectedId?.toString(),
            entity: NAMESPACES.AGENT_AVAILABILITY,
            connectionId,
            uid,
          },
        })
      )
    }
  }
  const getStatusSvg = (status: string) => {
    switch (status) {
      case AGENT_STATUS.AVAILABLE:
        return (
          <span className="absolute top-5 right-4 w-[0.875rem] h-[0.875rem] rounded-full bg-success-700"></span>
        )

      case AGENT_STATUS.OFFLINE:
        return (
          <div className="absolute top-5 right-4">
            <SvgOfflineStatus />
          </div>
        )

      case AGENT_STATUS.OUTBOUND:
        return (
          <div className="absolute top-5 right-4">
            <SvgOutboundStatus />
          </div>
        )

      case AGENT_STATUS.REPORTS:
        return (
          <div className="absolute top-5 right-4">
            <SvgReportsStatus />
          </div>
        )
      case AGENT_STATUS.BREAK:
        return (
          <div className="absolute top-5 right-4">
            <SvgBreakStatus />
          </div>
        )

      case AGENT_STATUS.LUNCH:
        return (
          <div className="absolute top-5 right-4">
            <SvgLunchStatus />
          </div>
        )

      case AGENT_STATUS.SYSTEM_DOWN:
        return (
          <span className="absolute top-5 right-4 w-[0.875rem] h-[0.875rem] rounded-full bg-customColors-orange"></span>
        )

      default:
        return (
          <span className="absolute top-5 right-4 w-[0.875rem] h-[0.875rem] rounded-full bg-secondary-550"></span>
        )
    }
  }

  useEffect(() => {
    if (
      messages?.action ||
      messages?.entity === NAMESPACES.AGENT_AVAILABILITY
    ) {
      if (!user) return
      if (messages?.connected_users) {
        const connectedUsers = messages?.connected_users as ConnectedUser[]
        const connectedUser = connectedUsers?.find(
          (userEntry) =>
            userEntry.agentId === user?.user_id &&
            userEntry?.action !== NAMESPACES.SUBSCRIBE
        )
        if (connectedUser) {
          setIsActive(connectedUser?.action === STRINGS.ONLINE)
          localStorage.setItem(
            STRINGS.ISACTIVE,
            (connectedUser?.action === STRINGS.ONLINE).toString()
          )
          sendMessageWbs(connectedUser)
        } else {
          hanldeSendMessage(
            wsHelper,
            sendMessage,
            connectionId,
            user,
            uid,
            selectedId
          )
        }
      } else if (messages?.action) {
        if (
          messages?.Agent_Id === user?.user_id &&
          messages?.Connection_Id !== connectionId
        ) {
          setIsActive(messages?.action === STRINGS.ONLINE)
          localStorage.setItem(
            STRINGS.ISACTIVE,
            (messages?.action === STRINGS.ONLINE).toString()
          )
        }
      }
    }
  }, [messages, user, selectedId])

  useEffect(() => {
    if (wsHelper && sendMessage && connectionId) {
      sendMessage(
        JSON.stringify({
          requestContext: {
            routeKey: NAMESPACES.SUBSCRIBE,
            userId: `${user?.user_id}`,
            'x-tenantId': selectedId?.toString(),
            entity: NAMESPACES.AGENT_AVAILABILITY,
            connectionId,
            uid,
          },
        })
      )
    }
  }, [connectionId, selectedId])

  useEffect(() => {
    dispatch(
      setAgentSubscribeTime({
        subscribeTime: Number(messages?.agent_login_time),
        agentId: `${user?.user_id}`,
      })
    )
  }, [messages])

  useEffect(() => {
    if (messages?.agent_login_time) {
      const currentTime = Date.now()
      const delay = Math.max(
        5 * 60 * 1000 -
          (currentTime - (loginTime ?? Number(messages?.agent_login_time))),
        0
      )
      const timer = setTimeout(() => {
        if (isActive === false) {
          dispatch(
            addToaster({
              message: NAMESPACES.MARK_AVAILABILITY_MSG,
              type: 'error',
              id: uuid(),
            })
          )
        }
      }, delay)

      return () => clearTimeout(timer)
    }
  }, [messages])

  useEffect(() => {
    handleThemeChange(display)
    localStorage.setItem('display-setting', JSON.stringify(display))
  }, [display])

  useEffect(() => {
    dispatch(setClientDropdown({ isVisible: false }))
    dispatch(setProgramDropdown({ isVisible: false }))
  }, [location])

  return (
    <header className="bg-accent-0 text-accent-0 py-2 px-6 h-[58px] w-full flex items-center font-primary  border-b-2 border-b-accent-100">
      <div className={`flex-shrink-0 pr-5`}>
        <button
          data-qa-id="nav-collapse-icon"
          onClick={toggleSideNav}
          className="cursor-pointer p-2"
        >
          <SvgBurger
            width={'24'}
            height="16"
            className={`${sideNavOpen ? 'svg-path-fill-secondary-500' : ''}`}
          />
        </button>
      </div>
      <div className="flex items-center gap-4">
        <SvgLogo />
        <BreadCrumb />
      </div>
      <div className="flex items-center ml-auto gap-5 min-w-0">
        {sessionLoginAtMs > 0 ? (
          <span
            className="text-xs text-accent-600 tabular-nums shrink-0"
            title={NAMESPACES.SESSION_LAST_LOGIN}
            data-qa-id="session-last-login-at"
          >
            {NAMESPACES.SESSION_LAST_LOGIN}: {formatSessionLoginAt(sessionLoginAtMs)}
          </span>
        ) : null}
        {mandatoryReloginRemainingMs !== null ? (
          <span
            className="text-xs text-accent-600 tabular-nums shrink-0"
            title={NAMESPACES.MANDATORY_SESSION_TIME_LEFT}
            data-qa-id="mandatory-session-time-remaining"
          >
            {NAMESPACES.MANDATORY_SESSION_TIME_LEFT}:{' '}
            {formatSessionTimeRemaining(mandatoryReloginRemainingMs)}
          </span>
        ) : null}
        {remainingMs !== null ? (
          <span
            className="text-xs text-accent-600 tabular-nums shrink-0"
            title={NAMESPACES.SESSION_INACTIVITY_TIME_LEFT}
            data-qa-id="session-idle-time-remaining"
          >
            {NAMESPACES.SESSION_INACTIVITY_TIME_LEFT}:{' '}
            {formatSessionTimeRemaining(remainingMs)}
          </span>
        ) : null}
        {isAwsPermission === 'true' && isLeader ? (
          <Button
            variant="secondary"
            title={showCCP ? AWS_STRINGS.HIDE_CCP : AWS_STRINGS.SHOW_CCP}
            className={`!p-3 portal-window border border-tertiary-200 ${
              showCCP ? '!bg-[#FFF4F4]' : ''
            }`}
            onClick={() => {
              dispatch(setDialPad({ number: '' }))
              dispatch(toggleCCP())
            }}
          >
            <SvgCallIconWorkflow
              width={'0.875rem'}
              height={'0.875rem'}
              fill={showCCP ? '#C8355A' : ''}
            />
          </Button>
        ) : null}

        {clientDropdownData.isVisible ? (
          <div className="flex items-center justify-center gap-2 text-accent-900">
            <span className="text-xs text-nowrap">
              {NAMESPACES.CLIENT_VERBIAGE}
            </span>
            <ClientDropdown
              onClientChange={clientDropdownData.onChange}
              isGlobalVisible={clientDropdownData.isGlobalVisible}
              setModal={clientDropdownData.setModal}
              isNested={clientDropdownData.isNested}
              onOptionChange={clientDropdownData.onOptionChange}
            />
          </div>
        ) : null}

        {programDropdownData.isVisible ? (
          <div className="flex items-center justify-center gap-2 text-accent-900">
            <span className="text-xs text-nowrap">
              {NAMESPACES.PROGRAM_VERBIAGE}
            </span>
            <ClientProgramDropdown />
          </div>
        ) : null}
        <div className="relative flex items-center">
          {userAuth && user && (
            <div className="flex gap-2 items-center">
              <Popover
                isOpen={openFlyoutPanel}
                onClose={(e) => {
                  if (buttonRef.current?.contains(e?.target as Node)) {
                    return
                  }
                  setOpenFlyoutPanel(false)
                }}
                buttonRef={buttonRef}
                content={
                  <FlyoutPanel
                    getInitials={getInitials}
                    user={user}
                    logOutClick={logOutClick}
                    handleRadioChange={handleRadioChange}
                    defaultDisplay={display}
                    setOpenProfilePanel={setOpenProfilePanel}
                    agentStatus={agentStatus}
                    isAwsPermission={isAwsPermission}
                  />
                }
                contentClassName="flex flex-col flex-1"
                cssClassName="min-w-flyout min-h-48 max-h-56 overflow-y-scroll hide-scrollbar mr-0 flex flex-col !p-0 custom-shadow"
                showCloseButton={false}
                closeOnOutsideClick={true}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    if (buttonRef.current?.contains(e.target as Node)) {
                      setOpenFlyoutPanel((prev) => !prev)
                    }
                  }}
                  ref={buttonRef}
                  className="flex gap-2 items-center cursor-pointer"
                  data-qa-id="profile-info"
                >
                  <div className="left">
                    <span className="flex items-center justify-center w-8 h-8 text-xs font-light rounded-full bg-primary-450 border text-primary-200">
                      {getInitials(`${user.first_name} ${user.last_name}`)}
                    </span>
                    {isAwsPermission === 'true'
                      ? getStatusSvg(agentStatus ?? '')
                      : null}
                  </div>
                  <SvgDropdownArrowGrey
                    className={openFlyoutPanel ? 'transform rotate-180' : ''}
                  />
                </button>
              </Popover>
            </div>
          )}
        </div>
        {openProfilePanel && (
          <Modal
            isOpen={openProfilePanel}
            closeModal={() => setOpenProfilePanel(false)}
            showCloseButton={false}
            closeModalOnOutsideClick={true}
            bodyCssClassName="mx-[9rem]"
            width="w-[70rem] h-[40rem]"
          >
            <MyProfile setOpenProfilePanel={setOpenProfilePanel} />
          </Modal>
        )}
      </div>
    </header>
  )
}

export default TopBar
